import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../services/translation';
import IndependentMultiSelector from './IndependentMultiSelector';
import IndependentSelector from './IndependentSelector';

export default class ShipCompanySelector extends Component {

    static propTypes = {
        name: PropTypes.string,
        defaultOptionLabel: PropTypes.string,
        onChange: PropTypes.func,
        resetFunction: PropTypes.func,
        isMulti: PropTypes.bool,
        hasSpecialIcon: PropTypes.bool,
        shipCompanies: PropTypes.array,
        shipRoutes: PropTypes.array,
        shipDirections: PropTypes.array,
        shipDays: PropTypes.array,
        selectedShipCompany: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        selectedShipRoute: PropTypes.string,
        selectedShipDirection: PropTypes.string,
        selectedDays: PropTypes.array
    };

    render() {
        const {name, defaultOptionLabel, shipCompanies, shipRoutes, shipDirections, shipDays, selectedShipCompany, selectedShipRoute, selectedShipDirection, selectedDays, onChange, resetFunction, hasSpecialIcon} = this.props;

        return (
            <div className={'plannerFilterElement'}>
                <div className="selectCustom">
                    <IndependentSelector
                        name={name}
                        selectedOption={selectedShipCompany}
                        options={shipCompanies}
                        defaultOptionLabel={defaultOptionLabel}
                        onChange={onChange}
                        hasSpecialIcon={true}
                    />
                </div>

                {(selectedShipCompany !== 0 && selectedShipCompany !== 'false' && selectedShipCompany !== '') && (
                    <div className="selectCustom">
                        <IndependentSelector
                            name="shipRoute"
                            selectedOption={selectedShipRoute}
                            options={shipRoutes}
                            defaultOptionLabel={translate('planner_list.choose_excursion_shiproute')}
                            onChange={onChange}
                            hasSpecialIcon={true}
                        />
                    </div>
                )}

                {(selectedShipRoute !== 0 && selectedShipRoute !== '') && (
                    <div className="selectCustom">
                        <IndependentSelector
                            name="shipDirection"
                            selectedOption={selectedShipDirection}
                            options={shipDirections}
                            defaultOptionLabel={translate('planner_list.choose_excursion_shipdirection')}
                            onChange={onChange}
                            hasSpecialIcon={true}
                        />
                    </div>
                )}

                {(selectedShipDirection !== 0 && selectedShipDirection !== '') && (
                    <IndependentMultiSelector
                        name="shipExcursionDays"
                        selectedOptions={selectedDays}
                        options={shipDays}
                        defaultOptionLabel={translate('planner_list.choose_excursion_excursionday')}
                        onChange={onChange}
                        resetFunction={resetFunction}
                        hasSpecialIcon={hasSpecialIcon}
                    />
                  )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Planner/ShipCompanySelector.js